/* eslint-disable typebox-snake-case/typebox-object-keys-snake-case -- camelCase keys match the website builder block JSON */
import { Static, Type } from '@sinclair/typebox';

/**
 * Champs de formulaire pilotés par le pro pour les blocs « Formulaire de contact »
 * (CONTACT_FORM) et « Demande de rappel » (CALLBACK_REQUEST) du website builder.
 *
 * Contrairement aux champs personnalisés de réservation (`booking_custom_field`, stockés
 * en DB et configurés dans le back-office), ces champs vivent **dans le JSON du bloc**
 * (`ComponentInstance.values.fields`) et sont édités directement dans le builder via
 * l'éditeur `input_type: 'form_fields_editor'`. Surensemble du type réservation : ajoute
 * `EMAIL` et `PHONE` pour que le pro puisse toujours recontacter le visiteur.
 */
export enum WebsiteFormFieldType {
  TEXT = 'TEXT',
  TEXTAREA = 'TEXTAREA',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  SELECT = 'SELECT',
  NUMBER = 'NUMBER',
  CHECKBOX = 'CHECKBOX',
  DATE = 'DATE',
}

export const WebsiteFormFieldTypeSchema = Type.Enum(WebsiteFormFieldType);

/** Cap raisonnable sur le nombre de champs par formulaire (UI + validation backend). */
export const MAX_WEBSITE_FORM_FIELDS = 20;

/**
 * Définition d'UN champ tel que configuré par le pro dans le builder.
 * - `id`       : identifiant stable du champ (clé React + clé d'« answer »), généré par l'éditeur.
 * - `options`  : valeurs proposées quand `type === SELECT` (le visiteur choisit une string).
 */
export const WebsiteFormFieldSchema = Type.Object({
  id: Type.String({ minLength: 1, maxLength: 64 }),
  label: Type.String({ minLength: 1, maxLength: 255 }),
  type: WebsiteFormFieldTypeSchema,
  required: Type.Optional(Type.Boolean()),
  placeholder: Type.Optional(Type.String({ maxLength: 255 })),
  options: Type.Optional(Type.Array(Type.String({ maxLength: 200 }), { maxItems: 50 })),
});
export type WebsiteFormField = Static<typeof WebsiteFormFieldSchema>;
